import { Observable, of } from 'rxjs';
import { IUserSettingsStatusService } from '../contracts/i-user-settings-status.service';

export class DefaultUserSettingsStatusService extends IUserSettingsStatusService {
  public getStatus(): Observable<string> {
    return of(null);
  }
}
